import {
    GET_ALL_COMMENTS_REQUEST,
    GET_ALL_COMMENTS_SUCCESS,
    GET_ALL_COMMENTS_FAIL,

} from '../constants/commentConstants'

export const getAllCommentsReducer = (state = { }, action) => {
    switch (action.type) {
        case GET_ALL_COMMENTS_REQUEST:
            return { loading: true }

        case GET_ALL_COMMENTS_SUCCESS:
            return { loading: false, comments: action.payload }

        case GET_ALL_COMMENTS_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}
